export default "__VITE_ASSET__SuxL0j8R__"